import * as React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { RiArrowRightLine } from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";

import { useLoader } from "../../Context/LoaderContext";
import { useToast } from "../../Context/ToastContext";

import "./Login.scss";

const initialFieldLogin = {
  reference: "",
  cin: "",
};

const LoginFinancing = () => {
  const [fieldLogin, setFieldLogin] = React.useState(initialFieldLogin);

  const [fieldErrorMessages, setFieldErrorMessages] =
    React.useState(initialFieldLogin);

  const [captchaDone, setIsCaptachDone] = React.useState(false);
    const [tokenRecaptcha, setTokenRecaptcha] = React.useState(null);
  
  const captchaRef = React.useRef(null);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  
    React.useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    const captchaSize = windowWidth > 480 ? "normal" : "compact";

  const navigate = useNavigate();
  const { setIsLoading } = useLoader();

  const { addToast } = useToast();

  const handleChangeField = (e, key) => {
    setFieldLogin((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
    setFieldErrorMessages(initialFieldLogin);
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();

    setIsLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/request-login`, {
        reference: fieldLogin.reference,
        cin: fieldLogin.cin,
        grt: tokenRecaptcha
      })
      .then((response) => {
        setIsLoading(false);

        const accessToken = response.data.data.simulation.temporary_token;
        localStorage.setItem(
          process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE_REQUEST,
          accessToken
        );

        if (response.data.status) {
          navigate("/details-financing-request");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        captchaRef.current.reset();
        setIsCaptachDone(false);

        if (error.response.data.errors) {
          setFieldErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  
  const onChangeCaptcha = (value) => {
    setIsCaptachDone(true);
    setTokenRecaptcha(value)
  };
  return (
    <>
      <h1 className="title">Suivre ma demande de financement</h1>
      <p className="sub-title">
        Veuillez saisir votre Numéro de Dossier et CIN
      </p>
      <form className="login-form" onSubmit={handleSubmit}>
        <Textfield
          label="Numéro de Dossier"
          name="reference"
          type="text"
          placeholder="Veuillez insérer votre numéro de dossier"
          size="large"
          autoComplete="on"
          value={fieldLogin.reference}
          onChange={(e) => handleChangeField(e, "reference")}
          hasError={fieldErrorMessages.reference}
          errorMessage={fieldErrorMessages.reference}
          required
        />
        <Textfield
          label="CIN / Matricule fiscal"
          name="cin"
          type="text"
          placeholder="Veuillez insérer votre CIN / Matricule fiscal"
          size="large"
          autoComplete="on"
          value={fieldLogin.cin}
          onChange={(e) => handleChangeField(e, "cin")}
          hasError={fieldErrorMessages.cin}
          errorMessage={fieldErrorMessages.cin}
          required
        />

        <div className="captcha-box">
          <ReCAPTCHA
            key={captchaSize}
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={captchaRef}
            onChange={onChangeCaptcha}
            size={captchaSize}
          />
        </div>

        <div className="wrap_actions_form mb-3">
          <Button type="submit" size="lg" disabled={captchaDone ? false : true}>
            Se connecter <RiArrowRightLine />
          </Button>
        </div>
      </form>
    </>
  );
};

export default LoginFinancing;
